import React from 'react';
import { Icon } from '@flashtalking/rhombus-react';

export default function RenderSuffix(field) {
	return (
		<div className="e-form__control-wrapper">
			<div className="e-form__control-header">
				<label htmlFor={field.input.name}>{field.label}</label>
			</div>
			<div className="suffix-container">
				<input type="text" className="e-form__input " {...field.input} />
				<button className="suffix-button" type="button" onClick={field.onUndo}>
					<Icon name="fas fa-undo" />
				</button>
			</div>
		</div>
	);
}
